<template>
  <div v-if="showMode" class="saveAnalysisClass onePictureDialog">
    <div class="headerClass">
      <span class="title">保存分析结果数据</span>
      <span @click="close()"><a-icon type="close" style="color: aliceblue; cursor: pointer" /></span>
    </div>

    <a-divider class="divider"></a-divider>

    <div class="contentInfo">
      <div class="formInfo">
        <a-form-model ref="form" :model="queryParam">
          <a-row>
            <a-col :md="24" :sm="24" v-if="!isArray">
              <a-form-model-item
                required
                prop="dataName"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="分析结果名称"
              >
                <a-input v-model="queryParam.dataName" :title='queryParam.dataName'></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24" v-else>
              <a-form-model-item prop="dataName" :labelCol="labelCol" :wrapperCol="wrapperCol" label="临时图斑名称">
                <a-input v-model="queryParam.dataName" :disabled="true"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24" style="margin-top: 8px">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文件夹">
                <a-tree-select
                  style="width: 100%"
                  class="treeSelect"
                  :value="queryParam.dirBsm"
                  :getPopupContainer="prpupContainer"
                  :dropdown-style="{ maxHeight: '240px', overflow: 'auto' }"
                  :tree-data="dirList"
                  :replaceFields="replaceFields"
                  :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
                  @change="selectDir"
                >
                </a-tree-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <a-divider class="divider"></a-divider>
      <div class="btnsClass">
        <a-button type="link" @click="cancel" class="cancelBtn">取消</a-button>
        <a-button type="link" @click="save" :loading='confirmLoading' class="confirmBtn">确定</a-button>
      </div>
    </div>
  </div>
</template>
  
<script>
  // import { postHeadersAction_ds } from '../../../../api/manage'
  import { mapGetters } from 'vuex'
  export default {
    name: 'saveAnalysis',
    data() {
      return {
        pageKey:'', // 页面对应的key  'djfx'-叠加分析  'hcfx'-缓冲分析  专题bsm-专题分析
        confirmLoading:false,
        showMode: false,
        projectBsm:'',
        queryParam: {
          dirBsm: null,
          dataName: null,
        },
        layer: {},
        layerArry: [],
        isArray: null,
        dirList: [],
        analyseName: null,
        replaceFields: {
          children: 'children',
          title: 'dirName',
          key: 'bsm',
          value: 'bsm',
        },
        treeDefaultExpandedKeys: [],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 9 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 14 },
        },
        hturl: {
          // 获取文件夹树结构
          getDirList: '/zcqc.wdsc/sys-sc-gis/getSysScGisDir',
          // 保存图斑
          saveLayer: '/zcqc.wdsc/sys-sc-gis/saveSysScGisDetail',
        },
      }
    },
    props: {
      // 选择的图层bsm
      selectLayerBsm: {
        type: String,
        default: '',
      },
      myCollectionTreeData:{
        type: Array,
        default: () => [],
      }
    },
    // mounted () {
    //   this.$bus.$on('completeAnalysisCollect',(res) => {
    //     this.close()
    //     this.$emit('saveSuccess', res, this.layer.id)
    //     this.confirmLoading = false
    //   });
    // },
    // beforeDestroy () {
    //   this.$bus.$off('completeAnalysisCollect');
    // },
    methods: {
      // 获取当前用户信息
      ...mapGetters(['userInfo']),
      // 关闭
      close() {
        this.$bus.$off('completeAnalysisCollect');
        this.showMode = false
      },
      // 初始化弹框信息
      /** 
       * @param {*} fwArry 图斑数据（核算任务是对象，其余是数组）
       * @param {arr} condition 配置统计信息
       * @param {string} name 分析弹框的名称
       * @param {number} methodsQuery 空间算法
       * @param {object} file 截图
       * @param {*} dialogPositionRight 弹框位置
       * @param {arr} attrValue 选择的图层的属性
       * @param {arr} projectBsm 选择的专题的bsm
       * @param {string} pageKey 页面的标识key  'djfx'-叠加分析  'hcfx'-缓冲分析  专题bsm-专题分析
       */
      setMap(fwArry, condition, name, methodsQuery, file,dialogPositionRight,attrValue,projectBsm,pageKey) {
        this.showMode = true
        this.pageKey = pageKey
        this.$nextTick(() => {
          let dialogEle = document.querySelector('.saveAnalysisClass')
          if(dialogPositionRight){
            dialogEle.style.right = dialogPositionRight
          }else{
            dialogEle.style.right = '100%'
          }
        })
        if (Array.isArray(fwArry)) {
          this.layer.fwData = JSON.stringify(fwArry)  // 图斑范围的数据
          this.layer.tjxxData = condition  // 配置统计信息的表格数据
          this.layer.methodsQuery = methodsQuery  // 相交还是相切
          this.layer.attrValue = attrValue
        } else {
          this.queryParam.dataName = fwArry.taskName ? fwArry.taskName : ''
          this.layer = fwArry
        }
        if (file) {
          this.layer.file = file
        }
        if (projectBsm) {
          this.layer.projectBsm = projectBsm
        }
        this.analyseName = name
        this.projectBsm = projectBsm
        this.dirList = this.myCollectionTreeData.filter(e => e.key == '3')[0].data
        this.dirList.unshift({ dirName: "无", bsm: "0", children: [] });
        this.$bus.$on('completeAnalysisCollect',(res) => {
          this.close()
          this.$emit('saveSuccess', res, this.layer.id)
          this.confirmLoading = false
        });
        // this.interDirList()
      },
      //  查询文件夹树方法
      interDirList() {
        let params = {}
        params.username = this.userInfo().realname
        params.dirType = '3'
        postHeadersAction_ds(this.hturl.getDirList, params, null)
          .then((res) => {
            if (res.code == 0) {
              this.dirList = res.data
              this.dirList.unshift({ dirName: '无', bsm: '0', children: [] })
              this.queryParam.dirBsm = '0'
            } else {
              this.$message.warning(res.msg)
            }
          })
          .finally(() => {})
      },
      // 取消
      cancel() {
        this.close()
      },
      // 保存
      save() {
        // 触发表单验证
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.confirmLoading = true
            let formData = new FormData()
            this.layer.layerBsm = this.selectLayerBsm
            this.layer.pageKey = this.pageKey
            formData.append('file', this.layer.file)
            formData.append('dataFrom', this.analyseName)  // 来源：叠加分析  缓冲分析  专题分析
            formData.append('dataName', this.queryParam.dataName)  // 图斑名称
            formData.append('dirBsm', this.queryParam.dirBsm)
            formData.append('dataContent', JSON.stringify(this.layer))
            formData.append('uname', this.userInfo().realname)
            formData.append('wjtpye', '3')  // 1-资源服务  2-临时图斑  3-分析结果
            if(this.layer.scGisId){
              formData.append('bsm', this.layer.scGisId)
            }
            this.$emit('analysisCollect',formData)
          } else {
            this.$message.error('缺少必填数据!')
            return false
          }
        })
      },
      // 文件夹选择方法
      selectDir(val) {
        this.queryParam.dirBsm = val
      },
      prpupContainer() {
        return document.querySelector('.ant-modal-body,.saveAnalysisClass') // ID是页面滚动的那个ID，根据自己来
      },
    },
  }
</script>
  
<style lang="less" scoped>
/**infoview浮动面板*/
.saveAnalysisClass {
  position: absolute;
  top: 20%;
  width: 360px;
  max-width: 360px;
  right: 100%;
  color: #ffffff;
  backdrop-filter: blur(15px);
  z-index: 100;
  .headerClass {
    width: 100%;
    height: 40px;
    opacity: 0.8;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
  }
  .contentInfo {
    width: 100%;
    height: 200px;
    .formInfo {
      width: 100%;
      height: 82%;
      padding-left: 10px;
      .treeSelect {
        width: 100% !important;
      }
    }
    .btnsClass {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .cancelBtn {
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }
}
.infoview-left {
  right: auto;
  left: 10px;
}

.saveAnalysisClass input,
.saveAnalysisClass select,
.saveAnalysisClass textarea {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.5);
  font-size: 14px;
}
/deep/ .ant-row.ant-form-item {
  margin-bottom: 0px;
  // 不要校验提示
  .ant-form-explain {
    display: none;
  }
}

/deep/ .ant-divider-horizontal {
  min-width: 94%;
  width: 94%;
  margin: auto !important;
}
</style>
  